
import { useState, useEffect } from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { OptimizedImage } from "@/components/ui/optimized-image";

interface PhotoFieldProps {
  form: UseFormReturn<any>; // Utilisé avec n'importe quel type de formulaire
  name?: string; // Permet de personnaliser le nom du champ
  label?: string; // Permet de personnaliser le label
}

export const PhotoField = ({ form, name = "photo", label = "Photo" }: PhotoFieldProps) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  
  // Récupérer la valeur actuelle du champ photo_url si elle existe
  const existingPhotoUrl = form.watch("photo_url");
  
  // Utiliser la valeur existante ou le nouvel aperçu
  const displayUrl = previewUrl || (typeof existingPhotoUrl === 'string' ? existingPhotoUrl : null);
  
  // Nettoyer l'URL de prévisualisation lorsque le formulaire est réinitialisé
  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
        setPreviewUrl(null);
      }
    };
  }, [previewUrl]);

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field: { value, onChange, ...field } }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          {displayUrl && (
            <div className="mb-4 relative aspect-video w-full max-w-xs overflow-hidden rounded-lg">
              <OptimizedImage
                src={displayUrl}
                alt="Aperçu de la photo"
                className="w-full h-full object-cover"
                priority={true}
                onError={() => console.error("Erreur lors du chargement de l'aperçu de l'image")}
              />
            </div>
          )}
          <FormControl>
            <Input 
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) {
                  console.log("Fichier sélectionné:", file.name, file.type, file.size);
                  onChange(file);
                  
                  // Créer un aperçu de l'image
                  if (previewUrl) {
                    URL.revokeObjectURL(previewUrl);
                  }
                  const objectUrl = URL.createObjectURL(file);
                  setPreviewUrl(objectUrl);
                  console.log("Nouvel aperçu URL:", objectUrl);
                }
              }}
              {...field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
